module.exports = __webpack_public_path__ + "314340aee2938374633af87937098218.svg";